export const FORM_IDENTIFIER = 'app/LocationFormPage';

export const INIT = 'app/LocationFormPage/INIT';
export const INIT_SUCCESS = 'app/LocationFormPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/LocationFormPage/INIT_FAILED';

export const SAVE = 'app/LocationFormPage/SAVE';
export const SAVE_SUCCESS = 'app/LocationFormPage/SAVE_SUCCESS';
export const SAVE_FAILED = 'app/LocationFormPage/SAVE_FAILED';

export const RESOLVE_LOCATION_DETAILS = 'app/LocationFormPage/RESOLVE_LOCATION_DETAILS';

export const REMOVE = 'app/LocationFormPage/REMOVE';
export const REMOVE_SUCCESS = 'app/LocationFormPage/REMOVE_SUCCESS';
export const REMOVE_FAILED = 'app/LocationFormPage/REMOVE_FAILED';
